import * as React from "react";
import { FieldProps } from "formik";
import { cx, css } from "@emotion/css";
import formGroupStyles from "../css/formgroup.module.css";

interface OtherProps {
  label: string;
  options: string[];
  optionsLabels: string[];
}

type FieldRadioSelectProps = OtherProps & FieldProps;

const FieldRadioSelect = ({
  field,
  form: { touched, errors, values, setFieldValue },
  label,
  options,
  optionsLabels
}: FieldRadioSelectProps): React.JSX.Element => {
  const fieldClasses = cx(
    formGroupStyles["form-group"],
    touched[field.name] && errors[field.name] ? formGroupStyles.error : ""
  );

  const radioButtonClass = css`
    display: inline-box;
    width: 100px;
    height: 60px;
    background-color: #f5f5f566;
    margin-right: 3px;
  `;

  const radioButtonSelected = css`
    border: 2px solid #5cb85c;
    border-radius: 3px;
  `;

  const radioGroupClass = css`
    display: inline-block;
    transform: translate(20%, 40%);
  `;

  return (
    <div className={fieldClasses}>
      {label ? <label htmlFor={field.name}>{label}</label> : null}
      <div>
        <div>
          {options.map((option, index) => (
            <label
              htmlFor={option}
              key={option}
              id={`rothPortionOption${option}`}
              className={cx(radioButtonClass, {
                [radioButtonSelected]: field.value === option
              })}
            >
              <div className={cx(radioGroupClass)}>
                <input
                  type="radio"
                  value={option}
                  name={option}
                  id={option}
                  checked={field.value === option}
                  onChange={e => {
                    setFieldValue(field.name, e.currentTarget.value);
                  }}
                />
                <span>{optionsLabels ? optionsLabels[index] : option}</span>
              </div>
            </label>
          ))}
        </div>
        <div className={formGroupStyles["error-messages"]}>
          {touched[field.name] && errors[field.name] && (
            <div id={`${field.name}ErrorMessage`}>
              {errors[field.name] as React.ReactNode}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FieldRadioSelect;
